import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import $ from "jquery";
class LoginForm extends Component {
  constructor() {
    super();
    this.user_login = this.check_user_login_info.bind(this);
    this.state = {
      login_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.user_login}>Login</button>,
    };
  }

  componentDidMount() {
   this.get_login_captcha_code();
  }

  get_login_captcha_code(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','login_captcha_code');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/login_url.php";
     }else{
       url = "/php/login_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var captcha_code = res.data;
        cutThis.create_captcha_code(captcha_code);
      })
      .catch(function (error) {
          console.log(error);
      });

  }

  create_captcha_code(captcha_code){
    var font_name = 'Arial';
    var captcha_color = 'red';
    document.getElementById('login_captcha_code').innerHTML = "";
       var captcha = captcha_code;
       var canv = document.createElement("canvas");
       canv.id = "login_captcha_code_div";
       canv.width = 100;
       canv.height = 50;
       var ctx = canv.getContext("2d");
       ctx.font = font_name;
       ctx.font = '20px Verdana';
       ctx.strokeStyle = captcha_color;
       ctx.strokeText(captcha, 0, 30);
       document.getElementById("login_captcha_code").appendChild(canv); // adds the canvas to the body element

  }

  check_user_login_info(){
    let cutThis         = this;
    var login_button     = '';//<button className="btn btn-primary w-100 py-3" type="button">Login...</button>;
    //cutThis.setState({login_button});
    $('label').removeClass('color_red');
    var email     = window.isNullAndUndef($('#email').val());
    var password  = window.isNullAndUndef($('#password').val());
    var code      = window.isNullAndUndef($('#code').val());
    var web_token = window.isNullAndUndef($('#web_token').val());
    if(email && password && code && web_token){
      var body = new FormData();
      body.append('email',email);
      body.append('password',password);
      body.append('code',code);
      body.append('web_token',web_token);
      body.append('function','check_user_login');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/login_url.php";
      }else{
        url = "/php/login_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          console.log(data);
          var msg = data['msg'];
          if(data['code']==1){
            var user_type = data['user_type'];
            var token = data['token'];
            window.location.href = "/"+user_type+"?token="+token+"&user_number="+msg+"&v=1";
          }else {
            $('#error_msg').text(msg).removeClass('hide').addClass('color_red');
          }
       })
       .catch(function (error) {
           console.log(error);
       });
    }else{
      window.change_lable_color('email','password','code');
      login_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.user_login}>Login</button>;
      cutThis.setState({login_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }

  render() {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <h1 className="text-center wow fadeInUp" data-wow-delay="0.1s">Login</h1>
                <div className="row g-4">

                 <div className="col-md-4"></div>

                    <div className="col-md-4">
                        <div className="wow fadeInUp" data-wow-delay="0.5s">
                            <p className="mb-4"></p>
                            <form action="." method="post">
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="email" name="email" placeholder="Email"/>
                                            <label for="name">Email</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="password" className="form-control" id="password" name="password" placeholder="Password"/>
                                            <label for="password">Password</label>
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <div className="form-floating">
                                            <p className="code-pm-zero">Code</p>
                                            <span id="login_captcha_code"></span>
                                        </div>
                                    </div>
                                    <div className="col-7">
                                        <div className="form-floating">
                                            <span onClick={() => this.get_login_captcha_code()}><i class="fa fa-2x fa fa-retweet text-primary reload-icon"></i></span>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="code" name="code" placeholder="Enter Code" maxlength="6"/>
                                            <label for="subject">Enter Code</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <Link to="/reset" className="reset-password">Reset Password</Link>
                                    </div>
                                    <div className="col-md-12">
                                        <p className="hide" id="error_msg"></p>
                                        {this.state.login_button}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-md-4"></div>

                </div>
            </div>
        </div>
    );
  }
}

export default LoginForm;
